import { Col, Container, Row } from "react-bootstrap";
import TurnoverForm from "../../../Components/Forms/TurnoverForm/TurnoverForm";
import { navigateTo } from "../../../redux/router/routerActions";
import { useAppDispatch } from "../../../redux/store";
import { useEditTurnoverMutation, useGetTurnoverByIdQuery } from "../../../services/bClientApi";
import { useParams } from "react-router-dom";

export default function EditTurnoverPage() {

    const { turnoverId = '' } = useParams()

    const {
        data,
        error,
        isLoading
    } = useGetTurnoverByIdQuery(turnoverId, { skip: !turnoverId })
    const turnoverData = data || {}

    const [
        editTurnover,
        {
            isLoading: isLoadingEdit,
            error: editError
        }
    ] = useEditTurnoverMutation()

    const dispatch = useAppDispatch()
    const handleSubmit = async (data: any) => {
        const values: any = {
            ...data
        }
        const updatedTurnover = await editTurnover({
            turnoverId: turnoverId,
            turnoverInfo: values
        }).unwrap()
        if (updatedTurnover._id) {
            dispatch(navigateTo(`/turnover/${updatedTurnover._id}`))
        }
        return updatedTurnover
    }

    return (
        <Container>
            <Row>
                <Col>
                    <h1>Edit Turnover</h1>
                    <hr />
                    {error && (<>{JSON.stringify(error)}<br /></>)}
                    {editError && (<>{JSON.stringify(editError)}<br /></>)}

                    {turnoverId && turnoverData && !isLoading && (
                        <TurnoverForm
                            initialValues={{
                                ...turnoverData,
                            }}
                            disabled={isLoading || isLoadingEdit}
                            onSubmit={handleSubmit}
                        />
                    )}

                </Col>
            </Row>
        </Container>
    )
}
